/**
 * Class strings shared by the review screens (exception review, deviations, reports). White-kit semantic tokens only
 * (design-system/MASTER.md): the file name is historical, the look is the one white system.
 */
export const CARD = "bg-surface rounded-lg border border-line shadow-card overflow-hidden";
export const CARD_BAR = "px-4 py-3 bg-subtle border-b border-line flex items-center justify-between gap-3";
export const CARD_TITLE = "font-sans text-base font-semibold text-ink";
export const FIELD =
  "rounded-md border border-line-strong bg-surface min-h-9 py-1.5 pl-2.5 pr-8 text-sm text-ink placeholder:text-ink-muted focus-visible:outline focus-visible:outline-[3px] focus-visible:outline-offset-1 focus-visible:outline-brand";
export const BTN_PRIMARY =
  "inline-flex min-h-9 w-fit items-center justify-center gap-1.5 rounded-md border border-brand bg-brand px-4 text-sm font-medium text-white hover:bg-brand-hover disabled:cursor-not-allowed disabled:border-line disabled:bg-subtle disabled:text-ink-muted";
export const BTN_SECONDARY =
  "inline-flex min-h-9 items-center justify-center gap-1.5 rounded-md border border-line-strong bg-surface px-3 text-sm font-medium text-ink hover:bg-subtle";
export const BTN_ROW =
  "mr-1 rounded-md border border-line px-2 py-1 text-xs font-medium text-ink-muted hover:bg-subtle";
export const BTN_ROW_ACTIVE =
  "mr-1 rounded-md border border-brand bg-brand-subtle px-2 py-1 text-xs font-semibold text-brand";
export const REFUSAL = "p-3 rounded-lg border border-alarm bg-alarm-subtle text-alarm text-sm";
export const SUCCESS = "p-3 rounded-lg border border-ok bg-ok-subtle text-ok text-sm";
export const TH = "py-2.5 px-4 text-xs font-medium text-ink-muted";

/** Severity pill classes, keyed by the API's severity / classification words. */
export const SEVERITY_PILL: Record<string, string> = {
  CRITICAL: "bg-alarm-subtle text-alarm border-alarm",
  MAJOR: "bg-warn-subtle text-warn border-warn",
  MINOR: "bg-info-subtle text-info border-info",
  INFO: "bg-subtle text-ink-muted border-line-strong",
};
